import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import axios from 'axios'
import { getFrontendConfig, getCurrentEnterpriseName } from '@/utils/enterprise-config'

let development = process.env.NODE_ENV == 'development' ? true : false

// 获取当前企业的前端配置
const frontendConfig = getFrontendConfig()

export default createStore({
  state: {
    development: development,
    
    // UI状态
    isShowLogin: !localStorage.getItem('accessToken'),
    isShowTable: false,
    isShowUpload: false,
    isShowDownload: false,
    isShowRecord: false,
    isHasDialog: false,
    searchKeyword: '',
    searchButton: 0,
    targetName: localStorage.getItem('targetName') || 'home',
    
    // 前端配置（静态，从域名识别）
    frontendConfig: frontendConfig,
    
    // 用户认证
    accessToken: localStorage.getItem('accessToken') || null,
    
    // 企业微信配置（直接从前端配置获取）
    wecomConfig: {
      corp_id: frontendConfig.corpId,
      expense_agent_id: frontendConfig.expenseAgentId,
      payment_agent_id: frontendConfig.paymentAgentId,
      finance_department_id: frontendConfig.financeDepartmentId,
      name: frontendConfig.enterpriseName,
      environment: frontendConfig.environment,
      loaded: true  // 直接标记为已加载
    },
  },
  getters: {
    getToken(state) {
      return state.accessToken
    },
    // 获取当前企业微信配置
    getWecomConfig(state) {
      return state.wecomConfig
    },
    // 获取企业微信 corpId
    getCorpId(state) {
      return state.wecomConfig.corp_id
    },
    // 获取报销应用 agentId
    getExpenseAgentId(state) {
      return state.wecomConfig.expense_agent_id
    },
    // 获取付款应用 agentId  
    getPaymentAgentId(state) {
      return state.wecomConfig.payment_agent_id
    },
    // === 前端配置获取器 ===
    // 获取API基础URL
    getApiBaseUrl(state) {
      return state.frontendConfig.apiBaseUrl
    },
    // 获取前端基础URL
    getFrontendBaseUrl(state) {
      return state.frontendConfig.frontendBaseUrl
    },
    // 获取企业显示名称
    getEnterpriseDisplayName(state) {
      return state.frontendConfig.displayName
    },
    // 获取主题配置
    getThemeConfig(state) {
      return state.frontendConfig.theme
    },
    // 获取财务部门ID
    getFinanceDepartmentId(state) {
      return state.wecomConfig.finance_department_id
    },
    
    // === 通用获取器 ===
    // 获取当前企业名称（后端识别用）
    getCurrentEnterpriseName(state) {
      return state.frontendConfig.enterpriseName
    },
    // 获取当前企业标识符（英文，用于API传递）
    getCurrentEnterpriseIdentifier(state) {
      return state.frontendConfig.enterpriseIdentifier
    },
    // 获取当前环境
    getCurrentEnvironment(state) {
      return state.frontendConfig.environment
    },
    
    // === 兼容性获取器（兼容旧代码） ===
    baseUrl(state) {
      return state.frontendConfig.apiBaseUrl
    },
    loaclUrl(state) {
      return state.frontendConfig.frontendBaseUrl
    },
  },
  mutations: {
    saveToken(state, token) {
      localStorage.setItem('accessToken', token)
      state.accessToken = token
    },
    removeToken(state) {
      localStorage.removeItem('accessToken')
      state.accessToken = null
      state.isShowLogin = true
    },
    changeTarget(state, name) {
      state.targetName = name
      localStorage.setItem('targetName', name)
    },
    updateIsHasDialog(state, value) {
      state.isHasDialog = value
    },
  },
  actions: {
    // 不再需要从后端获取配置，所有配置都在前端
  },
  modules: {},
  plugins: [],
})
